import { render } from "./BalanceTab.vue?vue&type=template&id=370f4b50"
import script from "./BalanceTab.vue?vue&type=script&lang=js"
export * from "./BalanceTab.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__